import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch9_p04 } from "../../../layouts/ch9_p04/ch9_p04";

export class Chapter9Page4 extends AbstractStoryState implements ReturnType<typeof ch9_p04> {
    readonly bg = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly lanterns = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch9_p04/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch9_p04/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch9_p04.call(this);
        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(3, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }
}